import { useTranslation } from "@/core/i18n";
import AgelessLogo from "atoms/icon/icons/ageless_logo.svg";

export function AgelessFooter() {
  const { t } = useTranslation();

  return (
    <footer className="flex w-full flex-col items-center gap-1 py-4">
      <a
        className="flex items-center"
        href="https://ageless.ai"
        rel="noopener noreferrer"
        target="_blank"
      >
        <AgelessLogo aria-label="Ageless AI" className="h-4 w-auto text-black" />
      </a>
      <p className="text-[10px] text-secondary">
        {t("agelessFooter.poweredBy")}{" "}
        <a
          className="underline underline-offset-2 hover:no-underline"
          href="https://ageless.ai"
          rel="noopener noreferrer"
          target="_blank"
        >
          Ageless.Ai
        </a>
      </p>
    </footer>
  );
}
